import { DemoAlarmSituationAlarm } from '@hakimo-ui/hakimo/types';
import {
  locationAlarmUrl,
  rawAlarmUrl,
  trackEvent,
} from '@hakimo-ui/hakimo/util';
import { Checkbox } from '@hakimo-ui/shared/ui-base';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';

interface Props {
  alarm: DemoAlarmSituationAlarm;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export function AlarmRow(props: Props) {
  const { alarm: a, checked, onChange } = props;

  // Location alarms deep-link by locationAlarmId; alarms without one (e.g.
  // enterprise alarms) are raw alarms and deep-link by alarmId instead.
  const viewUrl = a.locationAlarmId
    ? locationAlarmUrl(a.locationAlarmId, a.partitionKey)
    : rawAlarmUrl(a.rawAlarmId, a.partitionKey);

  return (
    <li className="flex items-center gap-3 px-3 py-2">
      <Checkbox
        checked={checked}
        disabled={!a.ingestible}
        onChange={onChange}
      />
      <div className="text-onlight-text-1 dark:text-ondark-text-1 min-w-0 flex-1 truncate text-sm">
        {a.description || (
          <span className="text-onlight-text-3 dark:text-ondark-text-3 italic">
            No description
          </span>
        )}
      </div>
      {viewUrl && (
        <a
          href={viewUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackEvent('view_demo_alarm')}
          title={
            a.locationAlarmId ? 'Open in Location Alarms' : 'Open in Alarms'
          }
          className="text-onlight-text-3 hover:text-onlight-text-1 dark:text-ondark-text-2 dark:hover:text-ondark-text-1 shrink-0"
        >
          <ArrowTopRightOnSquareIcon className="h-4 w-4" />
        </a>
      )}
    </li>
  );
}
